<template>
  <a-config-provider :locale="locale" :getPopupContainer="setRenderDom">
    <router-view />
  </a-config-provider>
</template>

<script>
  import zhCN from 'ant-design-vue/es/locale/zh_CN'

  export default {
    components: {},
    setup() {
      return {
        locale: zhCN,
      }
    },
  }
</script>

<style lang="scss">
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000;
    height: 100%;
  }
</style>
